// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getDatabase } from "firebase/database"
import { getAuth } from "firebase/auth"
import { getStorage } from "firebase/storage"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "ecoloco-app.firebaseapp.com",
  databaseURL: "https://ecoloco-app-default-rtdb.firebaseio.com",
  projectId: "ecoloco-app",
  storageBucket: "ecoloco-app.appspot.com",
  messagingSenderId: "1052615170216",
  appId: "1:1052615170216:web:cfb2fc377667bcc12fca9d",
  measurementId: "G-MC8654XE16",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const db = getDatabase(app)
export const auth = getAuth(app)
export const storage = getStorage(app)
